import ProxyMedLogo from "~/assets/icons/proxy-med-logo.svg";
import { Image, type ImageProps } from "@workspace/web-ui/components/image";

export function LogoWhite(props: Omit<ImageProps, 'src' | 'alt' | 'layout' | 'width' | 'height' | 'aspectRatio'>) {
  return <Image src="/assets/logo-black.svg" alt="Logo" layout="constrained" width={96} height={96} {...props} />;
}

export function LogoBlack(props: Omit<ImageProps, 'src' | 'alt' | 'layout' | 'width' | 'height' | 'aspectRatio'>) {
  return <Image src={ProxyMedLogo} alt="Logo" layout="constrained" width={96} height={96} {...props} />;
}